import React from 'react'
import styled, { css } from 'styled-components'
import { assetPrefix } from 'src/config/env_config'

const CurrentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 0 7px;
    margin-top: 8px;
    padding: 8px 0;
`
const Edit = styled.img`
    position:relative;
    margin-left: auto;
    cursor: pointer;
    z-index: 10;
`

const IconContainer = styled.div`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.iconSize ? `${props.iconSize}px` : '0px'};
`

export const Info = styled.div`
    margin-top: 8px;
    width: 100%;
    max-width: 200px;

    h2 {
        font-family: var(--primary-font);
        font-weight: 600;
        font-size: 16px;
        line-height: 19.2px;
        color: var(--gray-2);
    }
    h3 {
        font-family: var(--primary-font);
        font-weight: 400;
        font-size: 13px;
        color: var(--gray-5);

        ${({ isObs }) => isObs && css`
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        `}
    }
`

const EditableInfo = ({ noEdit, icon, iconAlt = 'Ítem', iconSize, title, additionalInfo, onEdit, isObs }) => {
  return (
    <CurrentInfo onClick={() => {
      if (!noEdit) onEdit()
    }}
    >
      <IconContainer iconSize={iconSize}>
        <img src={icon} width={iconSize} height={iconSize} alt={iconAlt} />
      </IconContainer>
      <Info isObs={isObs}>
        <h2>{title}</h2>
        {additionalInfo && <h3>{additionalInfo}</h3>}
      </Info>
      {!noEdit && <Edit src={`${assetPrefix}/static/icons/pen-outline.svg`} alt={`Editar ${iconAlt}`} />}
    </CurrentInfo>
  )
}

export default EditableInfo
